import type { PartialField } from '@certhon/models';

export type InsertableFieldType =
  | 'CHECKPOINT_FIELD'
  | 'NUMERIC_FIELD'
  | 'TASK_FIELD'
  | 'GROUP_FIELD';

export const FIELD_TYPE_OPTIONS: {
  type: InsertableFieldType;
  label: string;
}[] = [
  { type: 'CHECKPOINT_FIELD', label: 'Checkpoint' },
  { type: 'NUMERIC_FIELD', label: 'Numeric' },
  { type: 'TASK_FIELD', label: 'Task' },
  { type: 'GROUP_FIELD', label: 'Group' },
];

export function createPartialField(type: InsertableFieldType): PartialField {
  const base = { id: crypto.randomUUID(), created: new Date() };
  if (type === 'GROUP_FIELD') {
    return { ...base, type, title_en: '', title_nl: '' };
  }
  return {
    ...base,
    type,
    title_en: '',
    title_nl: '',
    description_en: '',
    description_nl: '',
    value: null,
    attachments: [],
  };
}
